// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"165":"caa7153e","6176":"caa7153e"}[chunkId] + ".chunk.css";
};